import React from "react";
import { useOutletContext } from "react-router-dom";
import SVIDivider from './../component/sviDivider';
import { exceptionHandler } from './../helper/helperException';
import Swal from 'sweetalert2'
import { apiReviews } from './../api/apiReviews';

export default function PageFeedback() {
    const [context, setContext] = useOutletContext({});
    const [disable, setDisable] = React.useState(!context?.message?.length);
    const [miniLoading, setMiniLoading] = React.useState(false);
    const hasClientInfo = (context?.source !== 'NPS')
    const isProd = (process.env.NODE_ENV === "production");

    const handleChange = event => {
        const tmpContext = context
        tmpContext[event.target.name] = event.target.value?.trim()
        setContext(tmpContext)
        setDisable(!tmpContext?.message?.length);
    }

    function handleSubmit(event) {
        event.preventDefault();
        setDisable(true);
        setMiniLoading(true);

        // Send data
        apiReviews.sendFeedback({ ...context })
            .then((res) => {
                // Local Log
                if (!isProd) {
                    localStorage.setItem("API/sendFeedback", JSON.stringify(res?.data));
                    debugger;
                }

                Swal
                    .fire({
                        html: context.isEnglish
                            ?
                            '<section>' +
                            '<div class="col-12"><div class="text-center fs-4 text-secondary">Thank you!</div></div>' +
                            `<div class="col-2 offset-5"><hr size="3" class="pt-1 m-0 opacity-75 text-${context.brand.color}"></div>` +
                            '<div class="col-12 mt-5 mb-4">Your message was successfully received by our team.</div>' +
                            '</section>'
                            :
                            '<section>' +
                            '<div class="col-12"><div class="text-center fs-4 text-secondary">Merci!</div></div>' +
                            `<div class="col-2 offset-5"><hr size="3" class="pt-1 m-0 opacity-75 text-${context.brand.color}"></div>` +
                            '<div class="col-12 mt-5 mb-4">Nous avons bien reçu votre message.</div>' +
                            '</section>',
                        showConfirmButton: true,
                        buttonsStyling: false,
                        confirmButtonText: '&nbsp;&nbsp;Close&nbsp;&nbsp;',
                        customClass: {
                            confirmButton: `btn btn-${context.brand.color}`,
                        },
                        padding: '3em 0',
                    })
                    .finally(() => {
                        window.open("about:blank", "_self");
                        window.close();
                        // setDisable(false);
                        // setMiniLoading(false);
                    })
                    .catch(ex => {
                        exceptionHandler(ex, "pageFeedback:apiReviews.sendFeedback", { context });
                        setDisable(false);
                        setMiniLoading(false);
                    })
            })
            .catch(ex2 => {
                exceptionHandler(ex2, "pageFeedback:apiReviews.sendFeedback2", { context });
                setDisable(false);
                setMiniLoading(false);
            });
    }

    return (
        <>
            <section className="row">
                <div className="col-12">
                    <div className="text-center fs-4 text-secondary">
                        {context.isEnglish ? "Share your feedback" : "Donnez votre avis"}
                    </div>
                </div>
                <SVIDivider color={context?.brand?.color} />
            </section>
            <section className="row px-5">
                <form className="row g-3 needs-validation" onSubmit={handleSubmit} noValidate>
                    <div className="col-12">
                        <label htmlFor="message" className="form-label">{context.isEnglish ? "Feedback" : "Commentaires"}<sup className="text-danger">*</sup></label>
                        <textarea type="text" className="form-control" rows={4}
                            name="message" onChange={handleChange} required />
                    </div>
                    {hasClientInfo && <>
                        <div className="col-12 col-md-6">
                            <label htmlFor="firstname" className="form-label">{context.isEnglish ? "First Name" : "Prénom:"}</label>
                            <input type="text" className="form-control" autoComplete="given-name"
                                name="firstName" onChange={handleChange} />
                        </div>
                        <div className="col-12 col-md-6">
                            <label htmlFor="lastname" className="form-label">{context.isEnglish ? "Last Name" : "Nom de famille"}</label>
                            <input type="text" className="form-control" autoComplete="family-name"
                                name="lastName" onChange={handleChange} />
                        </div>
                        <div className="col-12 col-md-6">
                            <label htmlFor="phone" className="form-label">{context.isEnglish ? "Phone" : "Téléphone"}</label>
                            <input type="tel" className="form-control" autoComplete="phone"
                                name="phone" onChange={handleChange} />
                        </div>
                        <div className="col-12 col-md-6">
                            <label htmlFor="email" className="form-label">{context.isEnglish ? "Email" : "Courriel"}</label>
                            <input type="email" className="form-control" autoComplete="email"
                                name="email" onChange={handleChange} />
                        </div>
                    </>}
                    <div className="col-12 text-center my-5">
                        <button
                            className={`btn text-uppercase btn-${disable ? "secondary" : context.brand.color}`}
                            type="submit"
                            disabled={disable}
                        >
                            <span>
                                {context.isEnglish ? "Send Message" : "Envoyer"}
                                {miniLoading && <i className={"fa fa-spinner fa-spin fa-1x ms-1"}></i>}
                            </span>
                        </button>
                    </div>
                </form>
            </section>
        </>
    );

}
